import { useRouter } from "next/router";
import { useEmrContext } from "@/hooks/emr-context";
import { getViewerRoute } from "@/utils/viewer-route";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";

/** Returns a handler that opens the DICOM viewer for a study of the currently selected patient. */
export function useOpenStudy() {
  var router = useRouter();
  var _useEmrContext = useEmrContext(),
    patientUid = _useEmrContext.patientUid;
  return function (studyId) {
    if (!patientUid || studyId == null) return;
    trackEvent(ANALYTICS_EVENTS.REPORT_DICOM_OPEN, {
      value: studyId
    });
    void router.push("".concat(getViewerRoute()).concat(patientUid, "?study_id=").concat(studyId), undefined, {
      shallow: true
    });
  };
}